import React, { useState } from "react";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";
import { IoLogoWhatsapp, IoIosMail } from "react-icons/io";
import EnquiryForm from "../components/Enquiryform";
import ModulesCovered from "../components/Modulescovered";
import ChooseCard from "../components/ChooseCard";
import ScrollToTop from "../components/ScrollTop";
import ServicesGrid from "../components/ServiceGrid";
import "../App.css";
import UniversityList from "./universitylist";
import ReviewContainer from "./star-rating";

import IntegrationCard from "./intergation";
import BusinessOutcomeComponent from "../components/bussiness";
import ScrollingText from "../components/lettersslider";
import CombinedComponent from "../components/combinecontact";
import DiscountComponent from "../components/discount";
import useScrollTransition from "../useScrollTransition";

const Home: React.FC = () => {
  const [showOrderModal, setShowOrderModal] = useState(false);
  const navigate = useNavigate();

  const toggleOrderModal = () => {
    setShowOrderModal(!showOrderModal);
  };
  const handleButtonClick = () => {
    navigate("/dissertation-writing-services"); // Navigate to the service page
  };

  useScrollTransition();

  return (
    <Layout>
      <div className="flex flex-col lg:flex-row justify-between items-center w-full max-w-1200pxs  mx-auto main-header component">
        <div className="overlay flex flex-col lg:flex-row justify-around items-center pt-16 lg:pb-12 lg:pt-36 lg:px-6 ">
          <div className="text-center lg:text-left max-w-full p-2 pt-8  lg:p-0 lg:w-1/2">
            <h1 className="text-2xl sm:text-3xl font-bold text-white	-100 component">
              Excel With{" "}
              <span
                style={{
                  background:
                    "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
                  padding: "0px 5px",
                }}
              >
                {" "}
                Matt Scholar Solutions:
              </span>
            </h1>
            <h1 className="text-1xl sm:text-2xl font-bold text-white	-100 mb-5 component">
              Trusted Online Assignment Help
            </h1>
            <div
              className="container block sm:hidden pt-6 pb-8 px-3 component"
              style={{
                borderRadius: "10px",
                position: "relative",

                border: "1px solid #EE6415 ",

                borderBottom: "3px solid #EE6415",
              }}
            >
              <input type="checkbox" id="ch" />
              <p className="text-base font-normal leading-6 text-white	-100 text-justify lg:pe-10 content">
                {" "}
                Experience top-tier assistance from experts for global students.
                Our dedicated team offers round-the-clock support, delivering
                outstanding and engaging projects. Simply choose your package
                and easily place orders through our platform. Our ordering
                process is straightforward: fill out a preset form for the Best
                Assignment Writing Service, describe your task and special
                requests, and leave the rest to us.{" "}
                <span style={{ fontSize: "18px" }}>......</span>
              </p>
              <div className="main-content">
                <p className="text-sm font-normal leading-6 text-white	-100 text-justify lg:pe-10">
                  Experience top-tier assistance from experts for global
                  students. Our dedicated team offers round-the-clock support,
                  delivering outstanding and engaging projects. Simply choose
                  your package and easily place orders through our platform. Our
                  ordering process is straightforward: fill out a preset form
                  for the Best Assignment Writing Service, describe your task
                  and special requests, and leave the rest to us. We edit,
                  proofread, and compose dissertations, essays, and assignments,
                  tailoring them to your instructions for excellent results.{" "}
                  <br />
                  <br />
                  Moreover, we continuously strive to improve and innovate our
                  services to meet the evolving needs of students worldwide. We
                  offer a variety of flexible packages and pricing options to
                  accommodate different budgets and academic levels. Our
                  commitment to transparency ensures that you know exactly what
                  to expect, with no hidden fees or surprises. We also provide a
                  secure and confidential service, protecting your personal
                  information and maintaining the highest standards of academic
                  integrity. With us, you can confidently achieve your academic
                  goals, knowing you have a reliable partner dedicated to your
                  success.
                </p>
                <label
                  htmlFor="ch"
                  className="px-3 py-2 mt-3"
                  style={{
                    position: "absolute",
                    borderRadius: "90%",
                    border: "none",
                    backgroundColor: "#5856d6",
                    color: "white",
                    left: "43%",
                  }}
                >
                  <i className="fa-solid fa-chevron-up"></i>
                </label>
              </div>
              <label
                htmlFor="ch"
                className="px-3 py-2 mt-3"
                style={{
                  position: "absolute",
                  borderRadius: "90%",
                  border: "none",
                  backgroundColor: "#5856d6",
                  color: "white",
                  left: "43%",
                }}
              >
                <i className="fa-solid fa-chevron-down"></i>
              </label>
            </div>

            <p className="text-base font-semibold hidden sm:block leading-6 text-white	-100 text-justify lg:pe-10">
              Experience top-tier assistance from experts for global students.
              Our dedicated team offers round-the-clock support, delivering
              outstanding and engaging projects. Simply choose your package and
              easily place orders through our platform. Our ordering process is
              straightforward: fill out a preset form for the Best Assignment
              Writing Service, describe your task and special requests, and
              leave the rest to us. We edit, proofread, and compose
              dissertations, essays, and assignments, tailoring them to your
              instructions for excellent results. <br />
              <br />
              Moreover, we continuously strive to improve and innovate our
              services to meet the evolving needs of students worldwide. We
              offer a variety of flexible packages and pricing options to
              accommodate different budgets and academic levels. Our commitment
              to transparency ensures that you know exactly what to expect, with
              no hidden fees or surprises. We also provide a secure and
              confidential service, protecting your personal information and
              maintaining the highest standards of academic integrity. With us,
              you can confidently achieve your academic goals, knowing you have
              a reliable partner dedicated to your success.
            </p>
            <div className="mt-8 sm:mt-5 flex justify-center sm:justify-start">
              <button className="bg-green-500 text-white	 border-none px-4 py-2 rounded-full cursor-pointer text-base hover:bg-green-700">
                <a href="https://wa.me/918547486582">
                  <div className="flex">
                    <IoLogoWhatsapp
                      className="me-1"
                      style={{ height: "30px", width: "30px" }}
                    />
                    <span className="mt-0.5 font-semibold">WhatsApp Now</span>
                  </div>
                </a>
              </button>
            </div>
          </div>

          <div className="shadow-2xl sm:shadow-none p-3 lg:p-0 rounded-lg component">
            <EnquiryForm />
          </div>
        </div>
      </div>
      <ScrollingText />

      <section id="about-us" className="p-0 lg:px-0 lg:pb-0 lg:pt-0">
        {/* <div className="flex flex-col lg:flex-row justify-around items-center al max-w-1200px mx-auto bg-none sm:bg-yellow-50 p-0 sm:px-4 sm:py-12 shadow-none sm:shadow-lg mt-0 sm:mt-0">
          <div className="lg:w-1/2 p-0 sm:p-4 mt-5 sm:mt-0 lg:pt-0">
            <h1
              className="text-2xl text-center sm:text-4xl sm:text-left  font-bold text-white	 sm:text-blue-950	Dark mb-4"
              style={{ color: "rgb(35,65,82)" }}
            >
              Why are we Best in <span style={{background:"linear-gradient(-96deg, rgb(255, 255, 255) 0%, rgb(255, 249, 220) 28%, rgb(280, 162, 49) 100%, rgb(255, 255, 255) 100%)",padding:"0px 2px",borderLeft:"2px solid rgba(253,150,16,1)"}}>Assignment Writing?</span>
            </h1>
            <div
              className="container block sm:hidden bg-white  py-8 px-4"
              style={{
                borderRadius: "10px",
                position: "relative",
                borderBottom: "2px solid #595757",
              }}
            >
              <input type="checkbox" id="mh" />
              <p className="font-semibold text-blue-950	Dark mb-4 text-justify content">
                Over the years, many assignment writing services have come and
                gone, but we have consistently stayed at the forefront. Our
                commitment to quality has kept us ahead, focusing on hiring the
                best PhD academic writers globally rather than investing heavily
                in promotion and advertisements. Despite the rising costs due to
                inflation, we ensure our service charges remain as low as
                possible. We specialize in handling urgent orders, with
                deadlines sometimes just a few hours away{" "}
                <span style={{ fontSize: "18px" }}>......</span>
              </p>
              <div className="main-content">
                <p className="font-semibold text-blue-950	Dark mb-4 text-justify">
                  Over the years, many assignment writing services have come and
                  gone, but we have consistently stayed at the forefront. Our
                  commitment to quality has kept us ahead, focusing on hiring
                  the best PhD academic writers globally rather than investing
                  heavily in promotion and advertisements. Despite the rising
                  costs due to inflation, we ensure our service charges remain
                  as low as possible. We specialize in handling urgent orders,
                  with deadlines sometimes just a few hours away. Our writers
                  excel under pressure, delivering high-quality work without
                  compromising on standards. Their professionalism and
                  efficiency are unmatched, making them the best in the field.
                </p>
                <p className="font-semibold text-blue-950	Dark text-justify">
                  In addition to our exceptional writing team, we offer
                  personalized customer service that sets us apart from the
                  competition. Our dedicated support staff is available 24/7 to
                  assist you with any queries or concerns, ensuring a smooth and
                  stress-free experience from start to finish. We understand
                  that each assignment is unique, and we take the time to
                  understand your specific requirements, tailoring our services
                  to meet your individual needs. Whether you're struggling with
                  a complex dissertation or need help with a last-minute essay,
                  you can trust us to provide reliable, top-quality assistance
                  every time. Our unwavering dedication to client satisfaction
                  and academic excellence has earned us a reputation as a
                  trusted leader in the assignment writing industry.
                </p>
                <label
                  htmlFor="mh"
                  className="px-3 py-2 mt-3"
                  style={{
                    position: "absolute",
                    borderRadius: "90%",
                    border: "none",
                    backgroundColor: "#5856d6",
                    color: "white",
                    left: "43%",
                  }}
                >
                  <i className="fa-solid fa-chevron-up"></i>
                </label>
              </div>
              <label
                htmlFor="mh"
                className="px-3 py-2 mt-3"
                style={{
                  position: "absolute",
                  borderRadius: "90%",
                  border: "none",
                  backgroundColor: "#5856d6",
                  color: "white",
                  left: "43%",
                }}
              >
                <i className="fa-solid fa-chevron-down"></i>
              </label>
            </div>
            <p
              className="font-semibold hidden sm:block text-blue-950	Dark mb-4 text-justify"
              style={{ color: "rgb(35,65,82)" }}
            >
              Over the years, many assignment writing services have come and
              gone, but we have consistently stayed at the forefront. Our
              commitment to quality has kept us ahead, focusing on hiring the
              best PhD academic writers globally rather than investing heavily
              in promotion and advertisements. Despite the rising costs due to
              inflation, we ensure our service charges remain as low as
              possible. We specialize in handling urgent orders, with deadlines
              sometimes just a few hours away. Our writers excel under pressure,
              delivering high-quality work without compromising on standards.
              Their professionalism and efficiency are unmatched, making them
              the best in the field.
            </p>
            <p
              className="font-semibold hidden sm:block text-blue-950	Dark text-justify"
              style={{ color: "rgb(35,65,82)" }}
            >
              In addition to our exceptional writing team, we offer personalized
              customer service that sets us apart from the competition. Our
              dedicated support staff is available 24/7 to assist you with any
              queries or concerns, ensuring a smooth and stress-free experience
              from start to finish. We understand that each assignment is
              unique, and we take the time to understand your specific
              requirements, tailoring our services to meet your individual
              needs. Whether you're struggling with a complex dissertation or
              need help with a last-minute essay, you can trust us to provide
              reliable, top-quality assistance every time. Our unwavering
              dedication to client satisfaction and academic excellence has
              earned us a reputation as a trusted leader in the assignment
              writing industry.
            </p>
          </div>
          <div className="lg:w-1/3 p-0  sm:p-4 mt-8 lg:mt-0 lg:p-0">
            <img src="professional-private-tutors.png" alt="Home" className="max-w-full" style={{borderTopLeftRadius:"10px",borderBottomLeftRadius:"10px"}}/>
          </div>
        </div> */}
        <BusinessOutcomeComponent />
        <div
          className="about-card"
          style={{ backgroundColor: "rgb(77,122,149)" }}
        >
          <div className="mt-0">
            <ModulesCovered />
          </div>
        </div>
      </section>
      <section id="services" className="p-0 sm:p-2 lg:p-0">
        <div className="px-5 py-8 rounded-lg mt-0 text-center">
          <h1
            className="text-2xl sm:text-4xl font-bold component"
            style={{ color: "rgb(29,35,42)" }}
          >
            Why{" "}
            <span
              style={{
                background:
                  "linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)",
                padding: "0px 2px",
                borderLeft: "2px solid rgba(253,150,16,1)",
              }}
            >
              Choose Us <b style={{ color: "rgb(255, 162, 49) " }}>?</b>
            </span>
          </h1>
          <p
            className="text-1xl sm:text-base font-semibold mt-1"
            style={{ color: "black" }}
          >
            We are committed to providing value for your money and time you
            invest with us
          </p>
        </div>
        <div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 text-center max-w-1200px mx-auto px-0 sm:px-4 mt-5"
          style={{ justifyItems: "center" }}
        >
          <ChooseCard />
        </div>
        <DiscountComponent />

        <div className="text-center mt-0">
          <div
            className="card-main pt-36 pb-12 flex flex-col lg:flex-row items-center component"
            style={{ justifyContent: "space-around" }}
          >
            <img
              src="pexels-rostislav-5011647-removebg.png"
              alt=""
              className="card-section top-0 lg:top-auto component1"
            />

            <div className="flex flex-col items-center">
              <h1 className="text-2xl sm:text-5xl font-bold text-white mb-3 mt-3 component">
                <span className="mb-2">Different Modules</span> <br />
                <span className="color-blow">
                  We Cover<b style={{ color: "rgb(249,115,23,0.9)" }}>!</b>
                </span>
              </h1>
              <p
                className="text-sm sm:text-base font-semibold text-white mt-1 mb-3 component"
                style={{ opacity: "0.8" }}
              >
                Take a look at what we got in hand for you
              </p>
              <button
                className="mt-2 py-3 px-2 btn-1 hidden lg:block component"
                style={{
                  border: "1px solid rgb(221,140,29)",
                  width: "50%",
                  color: "white",
                  position: "relative",
                }}
                onClick={handleButtonClick}
              >
                Explore Services <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>

            <ServicesGrid />
            <button
              className="mt-2 py-3 px-2 btn-1 block lg:hidden component"
              style={{
                border: "1px solid rgb(221,140,29)",
                width: "50%",
                color: "white",
                position: "relative",
              }}
              onClick={handleButtonClick}
            >
              Explore Services <i className="fa-solid fa-arrow-right"></i>
            </button>
          </div>

          <IntegrationCard />
        </div>
      </section>
      <section id="contact-us" className="p-">
        <div className=" text-center p-8">
          <h1
            className="text-2xl sm:text-3xl font-bold"
            style={{ color: "rgba(57,69,78,2)" }}
          >
            Quality Assignment Writing Support for{" "}
            <span
              style={{
                background:
                  "linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)",
              }}
            >
              All University & College
            </span>
          </h1>
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 text-gray-500 p-4 font-semibold">
            <h1>Our journey's so far</h1>
            <p>Free Topic Solution</p>
            <p>Affordable Price</p>
            <p>Subject Experts</p>
          </div> */}
          <UniversityList />
          {/* <div
            className="flex gap-2 sm:gap-0 justify-center mt-4"
            style={{ flexWrap: "wrap" }}
          >
            <button className="bg-green-500 text-white	 border-none px-4 py-2 mx-4 rounded-full cursor-pointer text-base hover:bg-green-700">
              <a href="https://wa.me/918547486582">
                <div className="flex">
                  <IoLogoWhatsapp
                    className="me-1"
                    style={{ height: "30px", width: "30px" }}
                  />
                  <span className="mt-0.5 font-semibold">WhatsApp Now</span>
                </div>
              </a>
            </button>
            <Link href="/OrderNow">
            <button className="bg-customPurple text-white border-none px-4 py-2 mx-4 rounded-full cursor-pointer text-base hover:bg-customPurpleDark">
              <div className='flex'>
                <FaShoppingCart className='me-1' style={{ height: "25px", width: "25px" }} />
                <span className='mx-6 font-semibold'>Order Now</span>
              </div>
            </button>
            </Link>
          </div>
          <div className="items-center mt-3">
            <button className="text-blue-950	 Dark font-bold px-4 py-2 mx-4 cursor-pointer text-base">
              <a href="mailto:matt@mattengg.com">
                <div className="flex">
                  <IoIosMail
                    className="mt-0.75 me-1"
                    style={{ height: "25px", width: "25px" }}
                  />
                  info@mattengg.com
                </div>
              </a>
            </button>
          </div> */}
        </div>
      </section>
      {/* <section className='bg-[rgb(254,252,232)] rounded-xl mx-[6px] mt-5 '> 
      <h2 className='text-xl text-center p-5 text-purple-900'>
      Relied on by Over 100 Million Students Globally
</h2>

 

      </section> */}
      {/* <section className='rounded-xl mx-[8px] m-3 '>  */}
      {/* <h1 className='p-4 text-center font-bold text-purple-700 text-2xl'>Our Customers Review About Online Assignment Help</h1> */}

      {/* <ReviewContainer /> */}
      <CombinedComponent />

      {/* </section> */}

      {showOrderModal && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="relative">
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <button
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                onClick={toggleOrderModal}
              >
                x
              </button>
              <EnquiryForm />
            </div>
          </div>
        </div>
      )}

      <ScrollToTop />
    </Layout>
    // <Service/>
  );
};

export default Home;
